export const BRAND_NAME = 'أ. عمر الخولي';
export const BRAND_FULL_NAME = 'منصة أ. عمر الخولي';
export const BRAND_TEACHER = 'أ/ عمر الخولي';

/** Site theme — synced with CSS design tokens in index.css */
export const THEME = {
  black: '#000031',
  primary: '#feef79',
  primaryDim: '#fbe14d',
  onPrimary: '#000031',
  accent: '#0084fc',
  onAccent: '#ffffff',
  darkBlue: '#1a365d',
  gray: '#3a353e',
  background: '#ffffff',
  surface: '#ffffff',
  onSurface: '#000031',
  onSurfaceVariant: '#6b7280',
  onMedia: '#edddd4',
  card1: '#e4e3f5',
  card2: '#ffd3dd',
  card3: '#e2eff0',
  card4: '#d8efc3',
  card5: '#fae285',
  card6: '#c5faff',
  /** @deprecated use black / accent — kept for hero transition */
  ink: '#000031',
  deep: '#1a365d',
  navy: '#000031',
  soft: '#6b7280',
  mist: '#ffffff',
  accentRgb: '0, 132, 252',
} as const;
